import * as Parse from 'parse';

export { configureDatamodel, getDatamodelConfiguration } from './configuration';
export { Parse };
